import _ from 'underscore';
import { PureKnockoutView } from '@bingads-webui/knockout-view';
import { FinalUrlSuffixView } from './view';
import template from '../shared/inline-edit/template.pug';
import ViewModel from '../shared/inline-edit/viewmodel';

/**
 * save event - When save button clicked, it fires with the new final url suffix.
 * It carries a parameter with format of { finalUrlSuffix }
 * @event FinalUrlSuffixInlineEditView#save
 * @type {Object}
 */

/**
 * close event - When cancel button clicked, it fires close event.
 *
 * @event FinalUrlSuffixInlineEditView#close
 * @type {void}
 */

/**
 * FinalUrlSuffixInlineEditView
 * will disable save button when input invalid
 *
 * @fires FinalUrlSuffixInlineEditView#save
 * @fires FinalUrlSuffixInlineEditView#close
 */
export class FinalUrlSuffixInlineEditView extends PureKnockoutView {
  /**
   * Initilize final url suffix
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.i18n - the localization settings
   * @param {Object} param.i18n.getString - localization settings function
   * @param {String} param.finalUrlSuffix - final url suffix
   * @returns {void} void
  */
  initialize({
    i18n,
    finalUrlSuffix,
  }) {
    super.initialize({ i18n, finalUrlSuffix });
    this.i18n = i18n;
    this.finalUrlSuffixView = new FinalUrlSuffixView({
      i18n,
      editMode: true,
      finalUrlSuffix,
    });

    this.finalUrlSuffixView.on('finalUrlSuffix:updated', ({ isValid }) => {
      this.viewModel.isValid(isValid);
    });

    this.viewModel.isValid(this.finalUrlSuffixView.isValid());

    this.setChild('childView', this.finalUrlSuffixView);
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default': 'cancel',
    };
  }

  get template() {
    return ({ model }) => template({ model, i18n: this.i18n });
  }

  get ViewModel() {
    return ViewModel;
  }

  /**
   * Fires save event after click save button
   *
   * @fires FinalUrlSuffixInlineEditView#save
   * @returns {void}
   */
  save() {
    this.trigger('save', { finalUrlSuffix: this.finalUrlSuffixView.getFinalUrlSuffix() });
  }

  /**
   * Fires close event after click cancel button
   *
   * @fires FinalUrlSuffixInlineEditView#close
   * @returns {void}
   */
  cancel() {
    this.trigger('close');
  }

  setErrors(errors) {
    if (errors && !_.isEmpty(errors) && _.isObject(errors)) {
      this.viewModel.error(errors[_.keys(errors)[0]]);
    } else {
      this.viewModel.error('');
    }
  }
}
